(() => {
  const init = () => {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer) return;

    drawer.addEventListener(
      'click',
      (e) => {
        const summary = e.target.closest('summary.menu-drawer__accordion-item');
        if (!summary) return;

        // Prevent the drawer's own click handlers from hijacking this tap
        e.stopPropagation();
      },
      true // capture phase so we beat theme listeners
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
